import React, { useState, useEffect } from "react";
import { Box, TextField, Typography } from "@mui/material";

import useAssessmentLabel from "../../../hooks/useAssessmentLabel";
import { Assessment } from "../../../interfaces/AssessmentInterfaces";

// @ts-expect-error - css
import styles from "../Assessment.module.css";

interface DermascopyProps {
  assessment: Partial<Assessment>;
  onChange: (value: string) => void;
}

const MAX_LENGTH = 2000;

// eslint-disable-next-line import/prefer-default-export
export const Dermascopy: React.FC<DermascopyProps> = ({ assessment, onChange }) => {
  const assessmentLabels = useAssessmentLabel();
  const [value, setValue] = useState(assessment.dermascopy || "");

  useEffect(() => {
    setValue(assessment.dermascopy || "");
  }, [assessment.dermascopy]);

  return (
    <Box className={styles.assessmentRow}>
      <Box className={styles.assessmentLabel} sx={{ display: "flex", alignItems: "center" }}>
        <Typography component="span" fontWeight="600">
          {assessmentLabels.dermascopy || "Dermascopy"}
        </Typography>
      </Box>

      <Box className={styles.assessmentField}>
        <TextField
          fullWidth
          label={assessmentLabels.dermascopy || "Dermascopy"}
          slotProps={{
            inputLabel: { shrink: true },
            htmlInput: { maxLength: MAX_LENGTH },
            formHelperText: { style: { position: "absolute", right: 0, bottom: 0, margin: 5 } }
          }}
          placeholder="Enter dermascopy observations"
          variant="outlined"
          margin="dense"
          multiline
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
          helperText={`${value.length}/${MAX_LENGTH}`}
        />
      </Box>
    </Box>
  );
};
